<template>
    <ul class="MediaSelector__selector" v-if="namespace && stockMedia.length > 0">
        <li v-for="item in stockMedia" :key="'media-' + namespace + '-stock-' + item.id" class="Media">
            <input :id="'media-' + namespace + '-stock-' + item.id"
                   :name="'media-' + namespace + '-stock[]'"
                   class="Media__input"
                   type="radio"
                   :value="item.id"
                   v-model="selectedImage"
                   @change="selectMedia(item)"
            >
            <label :for="'media-' + namespace + '-stock-' + item.id"
                   class="Media__label"
            >
                <span class="image-wrap">
                    <span class="image-inner">
                        <img v-if="item.extension === 'pdf'" :src="storage + 'placeholder/pdf-placeholder.jpg'" alt=""/>
                        <!-- Add selected image ID as query var to force reload -->
                        <img v-else :src="storage + item.directory + '/' + item.filename + '.' + item.extension + '?' + selectedImage"
                             alt=""
                        />
                    </span>
                </span>

                <span class="image-filename">
                    <span>
                        {{item.filename}}.{{item.extension}}
                    </span>
                </span>
            </label>
            <button class="selected" @click.stop="deselectMedia">
                <v-icon color="white">fas fa-check-circle</v-icon>
                <span style="width: 100%; flex: 0 0 100%; margin-top: 8px; ">
                    Click to deselect
                </span>
            </button>
        </li>
    </ul>
    <div class="MediaSelector__no-images" v-else>
        <p>There are no stock images for this field</p>
        <v-btn color="primary" @click="setUploadTab">
            <v-icon left small>fas fa-cloud-upload-alt</v-icon>
            <span>Click here to upload</span>
        </v-btn>
    </div>
</template>

<script>
import store from '@/store/store';

export default {
    props: {
        namespace: {
            type: String,
            required: true
        },

        uploadType: {
            type: String,
            required: true,
        },

        preloadedStockMedia: {
            type: Array,
        }
    },

    computed: {
        stockMedia: {
            get: function() {
                return store.state[this.namespace].stockMedia;
            },
            set: function(value) {
                store.commit(`${this.namespace}/setStockMedia`, value);
            }
        },

        selectedImage: {
            get: function() {
                return store.state[this.namespace].selectedImage;
            },
            set: function(value) {
                store.commit(`${this.namespace}/setSelectedImage`, value);
            }
        },

        selectedImageSrc: {
            get: function() {
                return store.state[this.namespace].selectedImageSrc;
            },
            set: function(value) {
                store.commit(`${this.namespace}/setSelectedImageSrc`, value);
            }
        }
    },

    data() {
        return {
            overlay: false,
            storage: this.$storageURL
        };
    },

    mounted() {
        store.commit(`${this.namespace}/toggleOverlay`, true);
        if (this.preloadedStockMedia) {
            store.dispatch(`${this.namespace}/preloadStockMedia`, this.preloadedStockMedia)
                .then(() => {
                    this.setSelected();
                })
                .catch(() => {
                    store.commit(`${this.namespace}/toggleOverlay`, false);
                });
        } else {
            store.dispatch(`${this.namespace}/getStockMedia`)
                .then(() => {
                    this.setSelected();
                })
                .catch(() => {
                    store.commit(`${this.namespace}/toggleOverlay`, false);
                });
        }
    },

    methods: {
        deselectMedia() {
            store.dispatch(`${this.namespace}/onThumbnailDeselect`, {item: '', namespace: this.namespace});
        },

        selectMedia(item){
            store.dispatch(`${this.namespace}/onThumbnailSelect`, {item: item, namespace: this.namespace});
        },

        setUploadTab() {
            store.commit(`${this.namespace}/setActiveTab`, 'upload');
        },

        setSelected() {
            store.dispatch(`${this.namespace}/setSelectedImage`, this.selectedImage)
                .then(() => {
                    store.dispatch(`${this.namespace}/getSelectedImage`)
                        .then(() => {
                            store.commit(`${this.namespace}/toggleOverlay`, false);
                        })
                        .catch(() => {
                            // Fall Back to the first image in the library.
                            store.dispatch(`${this.namespace}/setDefaultSelectedImage`);
                            store.commit(`${this.namespace}/toggleOverlay`, false);
                        });
                })
                .catch(() => {
                    store.commit(`${this.namespace}/toggleOverlay`, false);
                });
        }
    }
};
</script>
